import { format, isValid, parse } from "date-fns";
import { useState } from "react";

import { SearchBadge } from "./search_badge";

export type SearchQuery = {
  date: Date | null;
  query: string | null;
};

interface SearchBarProps {
  search: (query: SearchQuery) => Promise<void>;
  autoFocus?: boolean;
}

export const ymdDash = "yyyy-MM-dd";
const ymdSlash = "yyyy/MM/dd";
const dmyDash = "dd-MM-yyyy";
const dmySlash = "dd/MM/yyyy";

export const SearchBar = (props: SearchBarProps) => {
  const [searchState, setSearchState] = useState<SearchQuery>({
    date: null,
    query: null,
  });

  const parseTextToDate = (value: string | null): Date | null => {
    if (!value) {
      return null;
    }

    const trimmedValue = value.trim();

    if (!trimmedValue) {
      return null;
    }

    const supportedFormats = [ymdDash, ymdSlash, dmyDash, dmySlash];

    for (const dateFormat of supportedFormats) {
      const parsedDate = parse(trimmedValue, dateFormat, new Date());

      if (
        isValid(parsedDate) &&
        format(parsedDate, dateFormat) === trimmedValue
      ) {
        return parsedDate;
      }
    }

    return null;
  };

  const parseAndSearch = (e: FormData) => {
    const queryText = e.get("queryText") as string | null;

    if (queryText == "") {
      props.search(searchState);
      return;
    }

    const date = parseTextToDate(queryText);

    const nextSearchState = {
      date: date == null ? searchState.date : date,
      query: date == null ? queryText : searchState.query,
    };

    setSearchState(nextSearchState);

    props.search(nextSearchState);
  };

  const emptyDateSearch = () => {
    setSearchState((prev) => ({ ...prev, date: null }));
  };

  const emptyQuerySearch = () => {
    setSearchState((prev) => ({ ...prev, query: null }));
  };

  return (
    <form action={parseAndSearch}>
      <div className="join w-full max-w-full">
        <div className="w-full">
          <label className="input join-item w-full min-w-56 sm:min-w-80 md:min-w-96">
            <input
              className="w-full"
              type="text"
              name="queryText"
              placeholder="Zoek op naam of geboortedatum"
              autoFocus={props.autoFocus === true}
            />
          </label>
          <div className="mt-2 flex flex-wrap gap-2">
            {searchState.date && (
              <SearchBadge
                value={format(searchState.date, dmyDash)}
                onClear={emptyDateSearch}
              />
            )}
            {searchState.query && (
              <SearchBadge
                value={searchState.query}
                onClear={emptyQuerySearch}
              />
            )}
          </div>
        </div>
        <button className="btn btn-neutral join-item" type="submit">
          Zoeken
        </button>
      </div>
    </form>
  );
};
